import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/RemarkOption/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_edit_remark_option } from '../../../actions/v3/masterData';

const EditRemarkOption = (props) => {
    const location = useLocation();
    const data = location.state?.data ? JSON.parse(atob(location.state.data)) : null;
    const page = location.state?.page || 1;

    const onSubmit = (model) => {
        v3_edit_remark_option(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listRemarkOptionMasterData.url, { page });
            } else {
                toast.error(res.error?.message || res.error);
            }
        });
    };

    return (
        <Layout title="Edit Remark Option">
            <Form data={data} onSubmit={onSubmit} />
        </Layout>
    );
};

export default EditRemarkOption;
